import Company from '@/axios/Company'


let ajaxPost = function (url, data) {
    return new Promise((res, rej) => {
        let xhr = new XMLHttpRequest();
        xhr.open("POST",url,true);
        xhr.setRequestHeader("Content-type","application/x-www-form-urlencoded");
        xhr.send(JSON.stringify(data));
        xhr.onreadystatechange = (e) => {
            if (xhr.readyState == 4 && xhr.status == 200) {
                let datap = JSON.parse(xhr.responseText)
                res(datap)
            }
        }
    })
}

export default {
    userCurdApi: Company
}
